<template>
  <div class="mainForm">
    <div class="termsContainerDiv" style="height: 65vh; overflow-x: auto">
      <p>-	اوافق والتزم بجميع شروط واجراءات وقواعد قبول الطلاب الوافدين بجامعة الازهر 
        -	التزم بكافة الشروط وقواعد القبول وقررات المجلس الاعلي للازهر
        -	التزم بجميع الشروط والضوابط المنظمة للالتحاق بالبرامج الدراسية في جميع كليات جامعة الازهر 
        -	اقر بان البيانات المدخلة صحيحة وان بيانات الدفع الالكتروني البنكية صحيحة 
        -	التزم بتحميل صور واضحة من الاوراق الاتية ( صورة شخصية – الشهادة الثانوية – تضاف شهادة القدرات بالنسبة للثانوية السعودية  - جواز سفر ساري العمل به مدة لا تقل عن ستة اشهر من تاريخ التقديم ) 
        علي ان تكون جميع المستندات  بنفس الاسم 
        -	التزم عند التسجيل اذا كانت الام مصرية اقوم بتوضيح ذلك ويجب تحميل ما يثبت ذلك 
        (شهادة ميلاد المتقدم – بطاقة الرقم القومي للام )
        -	اقر بتحمل المسؤلية الكاملة عن اختيار رغباتي 
        -	التزم بسداد المصروفات الدراسية طبقا لما تنص عليه قواعد ولوائح الطلاب الوافدين بجامعة الازهر 
        -	اقر والتزم بان ترشيحي للكلية يعد ترشيحا مبدئيا ولا يعد ترشيح نهائي الا بعد تقديم الاوراق مطابقة لما تم تقديمه علي الموقع الالكتروني معتمدة وموثقة من الجهات المختصة 
        -	اوافق علي الالتزام بموعيد تقديم اصول الاوراق كاملة واقر بصحة البيانات المقدمة وصحة الشهادة و جواز السفر  واتحمل المسؤلية الكاملة في حالة تقديم اوراق مخالفة لما تم تقديمها علي الموقع الالكتروني في موعد اقصاه 21 يوما بعد الترشيح المبدئي والا سيكون ترشيحي لاغيا ولا يحق لي المطالبة بتنفيذه 
        -	اوافق علي الغاء ترشيحي في حالة اعتراض الجهات المختصة علي ترشيحي في اي وقت يصبح ترشيحي لاغيا 
        -	اتعهد بعدم المطالبة باسترداد المقابل النقدي للخدمات المقدمة علي الموقع الالكتروني 
        -	اوافق علي ان يتم الغاء التسجيل اذا تقدمنت اكثر من مرة او تقدمت مستندات غير صحيحة او غير مكتملة 
        -	I agree and commit to all the conditions, procedures, and rules for accepting foreign students at Al-Azhar University.
        -	I commit to all the conditions, admission rules, and decisions of the Supreme Council of Al-Azhar.
        -	I commit to all the regulations and requirements for enrolling in study programs in all faculties of Al-Azhar University.
        -	I acknowledge that the entered data is correct and that the electronic bank payment information is accurate.
        -	I commit to uploading clear photos of the following documents (personal photo, high school certificate, the Qudurat certificate for Saudi high school, a valid passport for a period of not less than six months from the date of application), and all documents should be under the same name.
        -	Upon registration, I commit to clarifying if my mother is Egyptian and must provide proof (applicant's birth certificate, national ID card for the mother).
        -	I acknowledge full responsibility for my choice of preferences.
        -	I commit to paying the tuition fees in accordance with the rules and regulations for foreign students at Al-Azhar University.
        -	I acknowledge and commit that my nomination for the college is preliminary and is not final until the submitted documents are verified on the official website and authenticated by the competent authorities.
        -	I agree to comply with the deadline for submitting all the original documents and acknowledge the accuracy of the information provided, the validity of the certificate, and the passport. I also assume full responsibility in case of submitting documents that contradict what was submitted on the official website within a maximum of 21 days after the preliminary nomination, otherwise, my nomination will be canceled, and I will not be entitled to demand its implementation.
        -	I agree to cancel my nomination if the competent authorities object to my nomination at any time, my nomination will be canceled.
        -	I undertake not to claim a refund for the cash payment for the services provided on the official website.
        -	I agree that registration will be canceled if I apply more than once or if I submit incorrect or incomplete documents.
        -	
        </p>
      <div class="bottomOverlay"></div>
    </div>
    <div style="text-align: center; color: #0f5887">
      <Checkbox v-model="acceptCbx" :binary="true" style="margin-inline: 5px" />
      {{ $t("readConfirmation") }}
    </div>
    <div class="flex m-3 justify-content-between">
      <Button
        :label="previousBtnTxt"
        class="btnClass"
        style="background-color: #0f5887; border: none"
        @click="previousPage"
        icon="pi pi-angle-left"
        iconPos="left"
      />
      <Button
        :label="doneBtnTxt"
        class="btnClass"
        @click="nextPage"
        iconPos="right"
        style="background-color: #d89436; border: none"
      />
    </div>
  </div>
</template>

<script>
import mixin from "../../../store/mixin.js";

export default {
  mixins: [mixin],

  data() {
    return {
      acceptCbx: false,
    };
  },
  computed: {
    doneBtnTxt() {
      return this.$t("doneBtnTxt");
    },
    previousBtnTxt() {
      return this.$t("previousBtnTxt");
    },
  },
  methods: {
    nextPage() {
      // this.$emit("nextPage", 8);
      if (!this.$store.getters["Auth_embassy/getViewOnly"]) {
        this.submitted = true;
        if (this.acceptCbx) {
          this.$store.commit("showLoaderFn", true);
          this.$store
            .dispatch("Terms_conditions_embassy/Save_TermsAndConditions", this.acceptCbx)
            .then((res) => {
              if (res.status) {
                // this.$toast.add({
                //   severity: "success",
                //   detail: this.$t("dataSavedSuccessfuly"),
                //   life: 3000,
                // });
                this.$swal.fire({
                  icon: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: this.$t("confirmButtonText"),
                  text: this.$t("dataSavedSuccessfuly"),
                });
                this.$emit("nextPage", 8);
                this.$store.commit("showLoaderFn", false);
              }
            })
            .catch((error) => {
              this.$store.commit("showLoaderFn", false);
              // this.$toast.add({
              //   severity: "error",
              //   detail: this.$t(error.response.data.Message),
              //   life: 3000,
              // });
               this.$swal.fire({
                icon: "error",
                confirmButtonColor: "#3085d6",
                confirmButtonText: this.$t("confirmButtonText"),
                text: this.$t(error.response.data.Message),
              });
            });
        }
      } else {
        this.$emit("nextPage", 8);
      }
    },
    previousPage() {
      this.$emit("nextPage", 6);
    },
  },
  created() {},
};
</script>

<style scoped>
.termsContainerDiv {
  padding: 10px;
}
.termsContainerDiv > p {
  margin-bottom: 10px;
  font-family: "Cairo";
  font-weight: bold;
}

.bottomOverlay {
  background: transparent linear-gradient(180deg, #ffffff00 0%, #ffffff 100%) 0% 0%
    no-repeat padding-box;
  height: 15vh;
  width: 100%;
  position: sticky;
  bottom: -2vh;
}

:deep(.p-button-icon) {
  font-size: 20px;
}
.mainForm {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
